export default {
  categorias: null,
  paId: null,
  preferencial: false,
  atendentePrincipal: null,
  atendenteSubstituto: null,
  nome: null,
  inative: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/mesamodel.js